<template>
<div class="main-container">
  <div v-if="showIntro && departmentsListData.length == 0">
   <tl-header type="h1">Departments</tl-header>
    <div class="row-container center">
      <div class="company-info">
        <img class="image" src="@/assets/bands.svg" />
        <!-- <div v-on:click="goToAddDepartmentsPage"><img class="closeImage" src="@/assets/close.png" /></div> -->
        <div class="fontStyle">
          <br><br><span>Department is a part of an organisation to which costs are charged for accounting purposes.
          </span><br>
          <div class="divider"></div><br><br>
          <btn text="Get Started" type="secondary" class="rightAlign" v-on:click="goToAddDepartmentsPage"></btn>
        </div>
      </div>
    </div>

    <bottom-action-container class="placeAtEnd" v-if="showIntro">
      <btn-skip @navClicked="skip"></btn-skip>
    </bottom-action-container>
  </div>
  <!-- <div v-show="!showIntro">
    <add-department @displayIntro="goToIntro"></add-department>
  </div> -->
  <div v-else>
    <departments-list @displayIntro="goToAddDepartmentsPage"></departments-list>
  </div>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
// import  AddDepartment from "./AddDepartment.vue";
import DepartmentsList from "./DepartmentsList.vue";
export default {
  name: "DepartmentPage",
  components: {
    // AddDepartment,
    DepartmentsList
  },
  computed: {
    ...mapState("onboard/departments", {
      departmentsListData: state => state.data,
    }),
    ...mapState("onboard/legal_entities", {
      isEnable: state => state.data
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
     }
    },
    data() {
      return {
        showIntro: true
      };
    },
    activated() {
      this.showIntro = true; //!this.isEnable[this.$route.params.entity_index].costCentreEnabled
      this.fetchDepartments();
      //this.showDepartmentsList = false;
    },

    methods: {
      ...mapActions("onboard/departments/", {
        fetch: "fetchAll",
        act_enable: "enable"
      }),
      ...mapMutations("onboard/legal_entities/", {
        enable_le: "updateEntityById"
      }),
      navHandler(navType) {
        this.$validator.reset();
        if (navType == "back") {
          this.$router.push({
            path: `/onboarding/entity/${
              this.$route.params.entity_index
            }/locations`
          });
        }
        if (navType == "next") {
          this.$validator.reset();
          this.$router.push({
            path: `/onboarding/entity/${this.$route.params.entity_index}/grades`
          });
        }
      },
      goToIntro() {
        this.showIntro = true;
        //this.showDepartmentsList = false;
      },

      // goToDepartmentsList(){
      //   this.showDepartmentsList = true;
      // },
      goToAddDepartmentsPage() {
        this.showIntro = false;
      },
      skip(){
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/costcenters`
        });
      },
      async fetchDepartments() {
        try {
          //console.log("fetchingDepartments");
          await this.fetch(this.le_id);
        } catch (err) {
          //console.log(err);
        }
      }
    }
};
</script>

<style lang="scss" scoped>
.image {
  margin-top: 30px;
}

.row-container {
  .value {
    margin-right: 0;
  }
}

.bottom-content {
  margin-top: 170px;
}

.bottom-content span {
  margin-bottom: 0;
  border-bottom: 1px solid #105ca4;
  border-bottom-color: #105ca4;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  color: #105ca4;
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

.closeImage {
  position: absolute;
  float: right;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;
}

.placeAtEnd {
  margin-top: 20px;
}
</style>
